(() => {
  const namespace = (window.LiljiuWishlist = window.LiljiuWishlist || {});
  if (namespace.storefrontInitialized) return;
  namespace.storefrontInitialized = true;

  const STORAGE_KEY = 'liljiu_wishlist_products';
  const GUEST_TOKEN_COOKIE = 'wishlist_guest';
  const GUEST_TOKEN_MAX_AGE = 60 * 60 * 24 * 365;
  const ACCOUNT_SYNC_PARAM = 'wishlist_after_login';
  const HEART_ICON_SVG = `
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.54 4Q19.195 4 20.437 4.76A5.05 5.05 0 0 1 22.338 6.82Q23 8.122 23 9.73L22.987 10.177Q22.9 11.72 22.214 12.9L22.01 13.231A8 8 0 0 1 20.288 15.164C19.528 15.772 18.326 16.5 17 17.35 15.443 18.339 13.576 19.607 12.456 20.905L12.41 20.953A.62.62 0 0 1 11.59 20.953L11.546 20.904C10.435 19.615 8.605 18.37 7 17.35 5.84 16.606 4.774 15.957 4.017 15.399L3.712 15.163A8 8 0 0 1 1.989 13.231L1.786 12.901Q1.1 11.72 1.013 10.177L1 9.729Q1.001 8.122 1.661 6.82 2.24 5.68 3.261 4.958L3.563 4.76Q4.803 4 6.462 4L6.71 4.004C9.26 4.094 10.789 5.547 12 7 13.25 5.5 14.745 4 17.54 4M17.54 6.5C14.79 6.5 13.206 8.757 12.345 10.335A.395.395 0 0 1 11.654 10.335C10.794 8.757 9.21 6.5 6.461 6.5 5.84 6.5 5.378 6.622 5.017 6.809L4.867 6.893C4.437 7.156 4.121 7.496 3.891 7.95 3.644 8.44 3.5 9.016 3.5 9.73 3.5 10.57 3.679 11.179 3.946 11.644A5.7 5.7 0 0 0 5.273 13.212L5.525 13.404C6.155 13.867 7.085 14.434 8.343 15.24L8.956 15.635C9.922 16.264 11.02 17.02 12.001 17.862 13.211 16.826 14.592 15.918 15.657 15.24 17.096 14.32 18.103 13.71 18.727 13.212 19.224 12.812 19.667 12.3 20.053 11.644 20.32 11.179 20.5 10.57 20.5 9.729 20.5 9.016 20.356 8.44 20.11 7.95L20.018 7.785A2.5 2.5 0 0 0 19.289 6.995L19.133 6.893C18.75 6.658 18.248 6.5 17.539 6.5"
      />
    </svg>
  `;
  const config = namespace.config || {};
  const state = {
    customerLoggedIn: config.customerLoggedIn === true,
    busyButtons: new WeakSet(),
    guestToken: readCookie(GUEST_TOKEN_COOKIE),
  };

  document.addEventListener('DOMContentLoaded', () => {
    initializeWishlist();
    initializeWishlistPage();
    bindVariantChanges();
    syncLocalWishlistForCustomerIfNeeded();
    syncWishlistAfterCustomerLoginIfNeeded();
  });

  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY) return;
    refreshAllWishlistState();
  });

  function initializeWishlist() {
    const buttons = Array.from(document.querySelectorAll('[data-liljiu-wishlist-button]'));

    buttons.forEach((button) => {
      if (button.dataset.liljiuWishlistBound === 'true') return;
      button.dataset.liljiuWishlistBound = 'true';
      rememberButtonLabels(button);
      button.addEventListener('click', onWishlistClick);
    });

    document.querySelectorAll('[data-liljiu-wishlist-link]').forEach((link) => {
      if (link.dataset.liljiuWishlistBound === 'true') return;
      link.dataset.liljiuWishlistBound = 'true';
      link.addEventListener('click', onWishlistLinkClick);
    });

    document.querySelectorAll('[data-wishlist-login-link]').forEach((link) => {
      if (link.dataset.liljiuWishlistBound === 'true') return;
      link.dataset.liljiuWishlistBound = 'true';
      link.addEventListener('click', onWishlistLoginClick);
    });

    refreshAllWishlistState();
  }

  function bindVariantChanges() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      const sectionId = event?.data?.sectionId;
      if (!sectionId) return;

      document
        .querySelectorAll(`[data-liljiu-wishlist-button][data-section-id="${sectionId}"]`)
        .forEach((button) => {
          if (button.dataset.location !== 'product' && button.dataset.location !== 'media') return;

          if (variant?.id) {
            button.dataset.selectedVariantId = String(variant.id);
            button.dataset.cartVariantId = String(variant.id);
            button.dataset.variantGid = `gid://shopify/ProductVariant/${variant.id}`;
            button.dataset.variantAvailable = String(variant.available);
            button.disabled = false;
          } else {
            delete button.dataset.selectedVariantId;
            delete button.dataset.variantGid;
            button.disabled = true;
          }

          const item = getStoredItem(button.dataset.productId);
          setButtonState(button, Boolean(item));
        });
    });
  }

  async function onWishlistClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;
    if (state.busyButtons.has(button)) return;

    const item = getButtonItem(button);
    if (!item.productId) return;

    setBusy(button, true);

    try {
      if (hasStoredItem(item.productId)) {
        await removeWishlistItem(item);
      } else {
        await addWishlistItem(item);
      }
    } finally {
      setBusy(button, false);
    }
  }

  function onWishlistLinkClick(event) {
    if (!state.customerLoggedIn) {
      event.preventDefault();
      window.location.href = config.wishlistUrl || '/pages/wishlist';
    }
  }

  async function onWishlistLoginClick(event) {
    event.preventDefault();
    const loginUrl = getWishlistLoginUrl(event.currentTarget.href);

    try {
      await syncStoredWishlistToServer({ createGuestToken: true });
    } catch (error) {
      console.error(error);
    } finally {
      window.location.href = loginUrl;
    }
  }

  function initializeWishlistPage() {
    const page = document.querySelector('[data-liljiu-wishlist-page]');
    if (!page) return;

    renderWishlistPage(page);
  }

  function refreshAllWishlistState() {
    const items = getStoredItems();
    refreshButtons(items);
    updateCount(items.length);

    const page = document.querySelector('[data-liljiu-wishlist-page]');
    if (page) renderWishlistPage(page, items);
  }

  function refreshButtons(items = getStoredItems()) {
    const ids = new Set(items.map((item) => item.productId));

    document.querySelectorAll('[data-liljiu-wishlist-button]').forEach((button) => {
      setButtonState(button, ids.has(button.dataset.productId));
    });
  }

  function renderWishlistPage(page, items = getStoredItems()) {
    const status = page.querySelector('[data-wishlist-page-status]');
    const empty = page.querySelector('[data-wishlist-page-empty]');
    const container = page.querySelector('[data-wishlist-page-items]');
    const loginNote = page.querySelector('[data-wishlist-page-login-note]');

    if (!container) return;

    const hasItems = items.length > 0;
    const showLoginNote = Boolean(loginNote && !state.customerLoggedIn && hasItems);

    page.classList.toggle('wishlist-page--empty', !hasItems);
    page.classList.toggle('wishlist-page--has-items', hasItems);
    page.classList.toggle('wishlist-page--guest', !state.customerLoggedIn);
    page.classList.toggle('wishlist-page--customer', state.customerLoggedIn);
    page.classList.toggle('wishlist-page--has-login-note', showLoginNote);

    if (status) status.hidden = true;
    container.replaceChildren();

    if (!hasItems) {
      if (empty) empty.hidden = false;
      if (loginNote) loginNote.hidden = true;
      updateCount(0);
      return;
    }

    if (empty) empty.hidden = true;
    if (loginNote) loginNote.hidden = !showLoginNote;

    renderWishlistPageItems(container, items);
    hydrateMissingProductImages(items, container);
  }

  function renderWishlistPageItems(container, items) {
    items.forEach((item) => {
      const row = document.createElement('article');
      row.className = 'wishlist-poster-card';
      row.dataset.productId = item.productId;
      if (item.title) row.setAttribute('aria-label', item.title);

      const mediaLink = document.createElement(item.url ? 'a' : 'div');
      mediaLink.className = 'wishlist-poster-card__media';
      if (item.url) mediaLink.href = item.url;

      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.imageAlt || item.title || 'Wishlist product image';
        image.loading = 'lazy';
        mediaLink.append(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.textContent = 'No image';
        mediaLink.append(placeholder);
      }

      const actions = document.createElement('div');
      actions.className = 'wishlist-poster-card__actions';

      const addToCart = document.createElement('button');
      addToCart.type = 'button';
      addToCart.className = 'button button--primary';
      addToCart.textContent = item.available === false ? 'Sold out' : 'Add to cart';
      addToCart.dataset.defaultText = addToCart.textContent;
      addToCart.dataset.loadingText = 'Adding...';
      addToCart.dataset.successText = 'Added';
      addToCart.disabled = !item.cartVariantId || item.available === false;
      addToCart.addEventListener('click', () => addWishlistItemToCart(addToCart, item.cartVariantId));
      actions.append(addToCart);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'wishlist-poster-card__remove';
      remove.setAttribute('aria-label', `Remove ${item.title || 'product'} from wishlist`);
      remove.innerHTML = HEART_ICON_SVG;
      remove.addEventListener('click', async () => {
        remove.disabled = true;
        remove.setAttribute('aria-busy', 'true');

        try {
          await removeWishlistItem(item);
        } finally {
          remove.disabled = false;
          remove.removeAttribute('aria-busy');
        }
      });

      row.append(mediaLink, actions, remove);
      container.append(row);
    });
  }

  async function hydrateMissingProductImages(items, container) {
    const missing = items.filter((item) => !item.image && item.handle);
    if (missing.length === 0 || typeof fetch !== 'function') return;

    await Promise.all(
      missing.map(async (item) => {
        try {
          const response = await fetch(`/products/${encodeURIComponent(item.handle)}.js`, {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return;

          const product = await response.json();
          const image = product.featured_image || product.images?.[0] || null;
          const title = product.title || item.title;
          if (!image && !title) return;

          const updated = {
            ...item,
            title,
            image: image || item.image,
            imageAlt: item.imageAlt || title,
            url: item.url || `/products/${product.handle || item.handle}`,
          };
          saveStoredItem(updated);

          const row = container.querySelector(`[data-product-id="${cssEscape(item.productId)}"]`);
          const media = row?.querySelector('.wishlist-poster-card__media');
          if (media && image && !media.querySelector('img')) {
            media.replaceChildren();
            const img = document.createElement('img');
            img.src = image;
            img.alt = updated.imageAlt || updated.title || 'Wishlist product image';
            img.loading = 'lazy';
            media.append(img);
          }
        } catch (error) {
          console.error(error);
        }
      })
    );
  }

  async function addWishlistItemToCart(button, cartVariantId) {
    if (!cartVariantId || typeof fetch !== 'function') return;

    const cart = getCartController();
    const originalText = button.dataset.defaultText || button.textContent;
    const formData = new FormData();
    formData.append('id', cartVariantId);
    formData.append('quantity', '1');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement?.(button);
    }

    const config = getCartFetchConfig();
    config.body = formData;
    const cartLinesUpdate = createCartLinesUpdateEvent(button, cartVariantId, 1);

    setCartButtonLoading(button, true);
    button.textContent = button.dataset.loadingText || 'Adding...';

    try {
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}`, config).then((result) =>
        result.json()
      );

      if (response.status) {
        publishCartError(cartVariantId, response);
        cartLinesUpdate?.reject(new Error(response.description || response.message || 'Unable to add item to cart'));
        throw new Error(response.description || response.message || 'Unable to add item to cart');
      }

      resolveCartLinesUpdate(cartLinesUpdate);

      if (!cart) {
        window.location = window.routes?.cart_url || '/cart';
        return;
      }

      publishCartUpdate(cartVariantId, response);
      renderCartContents(cart, response);
      button.textContent = button.dataset.successText || 'Added';
      window.setTimeout(() => {
        button.textContent = originalText;
      }, 1600);
    } catch (error) {
      button.textContent = originalText;
      console.error(error);
    } finally {
      setCartButtonLoading(button, false);
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    }
  }

  function getCartController() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getCartFetchConfig() {
    const config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
            },
          };

    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    return config;
  }

  function setCartButtonLoading(button, loading) {
    button.disabled = loading;
    button.toggleAttribute('aria-disabled', loading);
    button.classList.toggle('loading', loading);
  }

  function publishCartError(cartVariantId, response) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    publish(PUB_SUB_EVENTS.cartError, {
      source: 'wishlist-page',
      productVariantId: cartVariantId,
      errors: response.errors || response.description,
      message: response.message,
    });
  }

  function publishCartUpdate(cartVariantId, response) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'wishlist-page',
      productVariantId: cartVariantId,
      cartData: response,
    });
  }

  function renderCartContents(cart, response) {
    if (window.CartPerformance?.measure) {
      window.CartPerformance.measure('wishlist:add:paint-updated-sections', () => {
        cart.renderContents(response);
      });
      return;
    }

    cart.renderContents(response);
  }

  function createCartLinesUpdateEvent(target, variantId, quantity) {
    const { CartLinesUpdateEvent } = window.StandardEvents || {};
    if (!CartLinesUpdateEvent) return null;

    const deferred = CartLinesUpdateEvent.createPromise();
    target.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'wishlist',
        lines: [{ merchandiseId: variantId, quantity }],
        promise: deferred.promise,
      })
    );

    return deferred;
  }

  function resolveCartLinesUpdate(deferred) {
    if (!deferred) return;

    const { CartLinesUpdateEvent } = window.StandardEvents || {};
    if (!CartLinesUpdateEvent) return;

    const cartDataPromise =
      typeof CartItems !== 'undefined'
        ? CartItems.fetchCartData()
        : fetch(`${window.routes?.cart_url || '/cart'}.json`).then((response) => response.json());

    cartDataPromise
      .then((cart) => {
        if (!cart?.currency) {
          deferred.reject(new Error('Missing currency in cart response'));
          return;
        }

        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
      })
      .catch((error) => deferred.reject(error));
  }

  function getWishlistLoginUrl(fallbackUrl) {
    const loginUrl = fallbackUrl || config.loginUrl || '/account/login';
    const returnPath = getWishlistAccountSyncPath();

    try {
      const url = new URL(loginUrl, window.location.origin);
      url.searchParams.set('return_url', returnPath);
      return url.toString();
    } catch (error) {
      console.error(error);
      return loginUrl;
    }
  }

  async function syncWishlistAfterCustomerLoginIfNeeded() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(ACCOUNT_SYNC_PARAM)) return;

    const page = document.querySelector('[data-liljiu-wishlist-page]');
    const status = page?.querySelector('[data-wishlist-page-status]');

    if (status) {
      status.hidden = false;
      status.textContent = 'Syncing wishlist...';
    }

    try {
      await syncStoredWishlistToServer();

      if (config.customerAccountWishlistUrl) {
        window.location.href = config.customerAccountWishlistUrl;
        return;
      }

      url.searchParams.delete(ACCOUNT_SYNC_PARAM);
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      refreshAllWishlistState();
    } catch (error) {
      console.error(error);
      if (status) status.textContent = 'Wishlist could not be synced. Please refresh and try again.';
    }
  }

  function getWishlistAccountSyncPath() {
    const wishlistPath = config.wishlistUrl || '/pages/wishlist';

    try {
      const url = new URL(wishlistPath, window.location.origin);
      url.searchParams.set(ACCOUNT_SYNC_PARAM, '1');
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      console.error(error);
      return `/pages/wishlist?${ACCOUNT_SYNC_PARAM}=1`;
    }
  }

  async function syncLocalWishlistForCustomerIfNeeded() {
    if (!state.customerLoggedIn) return;
    if (new URL(window.location.href).searchParams.has(ACCOUNT_SYNC_PARAM)) return;

    try {
      await mergeGuestWishlistIfNeeded();
      await syncStoredWishlistFromServer();
    } catch (error) {
      console.error(error);
    }
  }

  async function mergeGuestWishlistIfNeeded() {
    if (!state.customerLoggedIn || !state.guestToken) return;

    const payload = await apiFetch('/merge', { method: 'POST' });
    if (payload.data?.mutation?.accepted === true) {
      clearGuestToken();
    }
  }

  async function syncStoredWishlistToServer({ createGuestToken = false } = {}) {
    const serverItems = uniqueServerItems(
      getStoredItems().map(getServerItemFromStoredItem).filter((item) => item.productGid)
    );

    if (serverItems.length === 0) return;

    await Promise.all(
      serverItems.map((item) =>
        apiFetch(
          '/items',
          {
            method: 'POST',
            body: JSON.stringify(item),
          },
          { createGuestToken }
        )
      )
    );
  }

  async function syncStoredWishlistFromServer() {
    const payload = await apiFetch('/bootstrap');
    const serverItems = payload.data?.wishlist?.items;
    if (!Array.isArray(serverItems)) return;

    reconcileStoredItemsWithServer(serverItems);
    refreshAllWishlistState();
  }

  async function addWishlistItem(item) {
    saveStoredItem(item);
    refreshAllWishlistState();

    if (!state.customerLoggedIn) return;

    try {
      await addStoredWishlistItemToServer(item);
    } catch (error) {
      console.error(error);
      removeStoredItem(item.productId);
      refreshAllWishlistState();
    }
  }

  async function removeWishlistItem(item) {
    const existing = getStoredItem(item.productId) || item;

    removeStoredItem(existing.productId);
    refreshAllWishlistState();

    if (!state.customerLoggedIn) return;

    try {
      await removeStoredWishlistItemFromServer(existing);
    } catch (error) {
      console.error(error);
      saveStoredItem(existing);
      refreshAllWishlistState();
    }
  }

  async function addStoredWishlistItemToServer(item, { createGuestToken = false } = {}) {
    const serverItem = getServerItemFromStoredItem(item);
    if (!serverItem.productGid) return;

    await apiFetch(
      '/items',
      {
        method: 'POST',
        body: JSON.stringify(serverItem),
      },
      { createGuestToken }
    );
  }

  async function removeStoredWishlistItemFromServer(item) {
    const serverItem = getServerItemFromStoredItem(item);
    if (!serverItem.productGid) return;

    const statusPayload = await apiFetch('/status', {
      method: 'POST',
      body: JSON.stringify({ items: [serverItem] }),
    });
    const wishlistItemId = statusPayload.data?.items?.[0]?.wishlistItemId;
    if (!wishlistItemId) return;

    await apiFetch(`/items/${encodeURIComponent(wishlistItemId)}`, {
      method: 'DELETE',
    });
  }

  function getServerItemFromStoredItem(item) {
    return {
      productGid: item.productGid || (item.productId ? `gid://shopify/Product/${item.productId}` : null),
      variantGid:
        item.variantGid ||
        variantGidFromNumericId(item.selectedVariantId) ||
        variantGidFromNumericId(item.cartVariantId) ||
        null,
    };
  }

  function uniqueServerItems(items) {
    const lookup = new Map();

    items.forEach((item) => {
      lookup.set(`${item.productGid}:${item.variantGid || ''}`, item);
    });

    return Array.from(lookup.values());
  }

  function reconcileStoredItemsWithServer(serverItems) {
    const localItems = getStoredItems();
    const localLookup = new Map();

    localItems.forEach((item) => {
      localLookup.set(`${item.productGid || ''}:${item.variantGid || ''}`, item);
      localLookup.set(`${item.productId || ''}:${item.variantGid || ''}`, item);
    });

    const nextItems = serverItems
      .map((serverItem) => {
        const productId = productIdFromGid(serverItem.productGid);
        if (!productId) return null;

        const localItem =
          localLookup.get(`${serverItem.productGid || ''}:${serverItem.variantGid || ''}`) ||
          localLookup.get(`${productId}:${serverItem.variantGid || ''}`) ||
          localItems.find((item) => item.productId === productId) ||
          {};
        const variantId = numericIdFromGid(serverItem.variantGid);

        return {
          productId,
          productGid: serverItem.productGid || localItem.productGid || null,
          variantGid: serverItem.variantGid || localItem.variantGid || null,
          selectedVariantId: localItem.selectedVariantId || variantId || null,
          cartVariantId: localItem.cartVariantId || variantId || null,
          handle: localItem.handle || null,
          title: localItem.title || '',
          url: localItem.url || '',
          image: localItem.image || '',
          imageAlt: localItem.imageAlt || '',
          available: localItem.available === false ? false : true,
          addedAt: serverItem.addedAt || localItem.addedAt || new Date().toISOString(),
        };
      })
      .filter(Boolean);

    writeStoredItems(nextItems);
  }

  async function apiFetch(path, init = {}, options = {}) {
    const guestToken = getGuestToken({ create: options.createGuestToken === true });
    const response = await fetch(`${getApiBase()}${path}`, {
      ...init,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(guestToken ? { 'X-Wishlist-Guest-Token': guestToken } : {}),
        ...(init.body ? { 'Content-Type': 'application/json' } : {}),
        ...(init.headers || {}),
      },
    });
    const payload = await response.json().catch(() => null);

    if (!response.ok) {
      const error = new Error(payload?.data?.message || `Wishlist request failed with ${response.status}`);
      error.status = response.status;
      error.payload = payload;
      throw error;
    }

    return payload;
  }

  function getApiBase() {
    return config.apiBase || '/apps/wishlist';
  }

  function getGuestToken({ create = false } = {}) {
    if (!state.guestToken && create && getStoredItems().length > 0) {
      state.guestToken = createGuestTokenValue();
      writeGuestToken(state.guestToken);
    }

    return state.guestToken;
  }

  function createGuestTokenValue() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();

    if (window.crypto?.getRandomValues) {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    }

    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  }

  function readCookie(name) {
    const value = document.cookie
      .split(';')
      .map((entry) => entry.trim())
      .find((entry) => entry.startsWith(`${name}=`));

    return value ? decodeURIComponent(value.split('=').slice(1).join('=')) : null;
  }

  function writeGuestToken(token) {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${GUEST_TOKEN_COOKIE}=${encodeURIComponent(
      token
    )}; Path=/; Max-Age=${GUEST_TOKEN_MAX_AGE}; SameSite=Lax${secure}`;
  }

  function clearGuestToken() {
    state.guestToken = null;
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${GUEST_TOKEN_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
  }

  function getButtonItem(button) {
    const selectedVariantId = button.dataset.selectedVariantId || null;
    const cartVariantId = button.dataset.cartVariantId || selectedVariantId || null;

    return {
      productId: button.dataset.productId || productIdFromGid(button.dataset.productGid),
      productGid: button.dataset.productGid || null,
      variantGid: button.dataset.variantGid || variantGidFromNumericId(selectedVariantId) || variantGidFromNumericId(cartVariantId),
      selectedVariantId,
      cartVariantId,
      handle: button.dataset.productHandle || null,
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '',
      image: button.dataset.productImage || '',
      imageAlt: button.dataset.productImageAlt || button.dataset.productTitle || '',
      available: button.dataset.variantAvailable === 'false' ? false : true,
      addedAt: new Date().toISOString(),
    };
  }

  function productIdFromGid(gid) {
    if (!gid) return '';
    return gid.split('/').pop() || '';
  }

  function numericIdFromGid(gid) {
    if (!gid) return null;
    const id = gid.split('/').pop();
    return id && /^\d+$/.test(id) ? id : null;
  }

  function variantGidFromNumericId(id) {
    if (!id || String(id).startsWith('gid://shopify/ProductVariant/')) return id || null;
    return /^\d+$/.test(String(id)) ? `gid://shopify/ProductVariant/${id}` : null;
  }

  function getStoredItems() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];

      return parsed
        .filter((item) => item && item.productId)
        .map((item) => ({
          productId: String(item.productId),
          productGid: item.productGid || null,
          variantGid: item.variantGid || null,
          selectedVariantId: item.selectedVariantId || null,
          cartVariantId: item.cartVariantId || null,
          handle: item.handle || null,
          title: item.title || '',
          url: item.url || '',
          image: item.image || '',
          imageAlt: item.imageAlt || '',
          available: item.available === false ? false : true,
          addedAt: item.addedAt || new Date().toISOString(),
        }));
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  function writeStoredItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function getStoredItem(productId) {
    return getStoredItems().find((item) => item.productId === String(productId)) || null;
  }

  function hasStoredItem(productId) {
    return Boolean(getStoredItem(productId));
  }

  function saveStoredItem(item) {
    const items = getStoredItems().filter((stored) => stored.productId !== String(item.productId));
    items.unshift({
      ...item,
      productId: String(item.productId),
      addedAt: item.addedAt || new Date().toISOString(),
    });
    writeStoredItems(items);
  }

  function removeStoredItem(productId) {
    writeStoredItems(getStoredItems().filter((item) => item.productId !== String(productId)));
  }

  function rememberButtonLabels(button) {
    const text = getButtonTextElement(button);
    if (!text) return;

    button.dataset.defaultLabel = button.dataset.defaultLabel || text.textContent.trim();
    button.dataset.wishlistedLabel = button.dataset.wishlistedLabel || 'Added to wishlist';
  }

  function setButtonState(button, wishlisted) {
    button.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    button.closest('.card__wishlist')?.classList.toggle('is-wishlisted', wishlisted);
    button.setAttribute(
      'aria-label',
      wishlisted
        ? button.dataset.removeLabel || 'Remove from wishlist'
        : button.dataset.addLabel || button.dataset.defaultLabel || 'Add to wishlist'
    );

    updateButtonText(button, wishlisted);
  }

  function updateButtonText(button, wishlisted) {
    if (button.dataset.location === 'card') return;

    const text = getButtonTextElement(button);
    if (!text) return;

    text.textContent = wishlisted
      ? button.dataset.wishlistedLabel || 'Added to wishlist'
      : button.dataset.defaultLabel || 'Add to wishlist';
  }

  function getButtonTextElement(button) {
    return button.querySelector('.wishlist-button__text, .liljiu-wishlist-button__text');
  }

  function setBusy(button, busy) {
    if (busy) {
      state.busyButtons.add(button);
      button.setAttribute('aria-busy', 'true');
    } else {
      state.busyButtons.delete(button);
      button.removeAttribute('aria-busy');
    }
  }

  function updateCount(count) {
    document.querySelectorAll('[data-liljiu-wishlist-count]').forEach((bubble) => {
      const link = bubble.closest('[data-liljiu-wishlist-link]');
      const visible = Number.isFinite(count) && count > 0;

      bubble.hidden = !visible;
      link?.classList.toggle('has-items', visible);

      if (!visible) {
        bubble.querySelector('[aria-hidden="true"]').textContent = '';
        const hiddenText = bubble.querySelector('.visually-hidden');
        if (hiddenText) hiddenText.textContent = 'Saved products';
        return;
      }

      const text = count > 99 ? '99+' : String(count);
      bubble.querySelector('[aria-hidden="true"]').textContent = text;
      const hiddenText = bubble.querySelector('.visually-hidden');
      if (hiddenText) hiddenText.textContent = `Saved products: ${count}`;
    });
  }

  function cssEscape(value) {
    if (window.CSS?.escape) return window.CSS.escape(String(value));
    return String(value).replace(/"/g, '\\"');
  }
})();
